// ============================================================
// FILE: src/App.js - Fixed imports
// ============================================================
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import Navbar from './componenets/Navbar';
import Footer from './componenets/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import WhyChooseUs from './pages/WhyChooseUs';
import Gallery from './pages/Gallery';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-[var(--color-surface)] text-[var(--color-dark)] font-sans">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
                        <Route path="/why-choose-us" element={<WhyChooseUs />} />

            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <a
          href="https://wa.me/919650846272"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contact us on WhatsApp"
          className="fixed bottom-4 right-4 z-50 flex items-center justify-center rounded-full bg-[var(--color-accent)] p-3 text-white shadow-lg shadow-[#F36A16]/30 transition duration-300 hover:bg-[#d85e12] sm:bottom-6 sm:right-6 sm:p-4"
        >
          <MessageCircle className="h-6 w-6 sm:h-7 sm:w-7" />
        </a>
        <Footer />
      </div>
    </Router>
  );
}

export default App;